const sort_alphabetically = (array: any, key: string, direction = 1) =>
  array &&
  array.length > 0 &&
  array.sort((el1: any, el2: any) =>
    el1[key].toLowerCase() > el2[key].toLowerCase()
      ? 1 * direction
      : -1 * direction
  );

const sort_chronologically = (array: any, key: string, direction: number) =>
  array &&
  array.sort((a: any, b: any) =>
    new Date(b[key]) < new Date(a[key]) ? 1 * direction : -1 * direction
  );

export { sort_alphabetically, sort_chronologically };
